<template>
    <div class="ins-product-box ins-element-link ins-sr-api listing-item item_search"
        :ins-product-id="item.item_id"
        :data-product-categories="item?.category"
        event-collection="true">
        <NuxtLink
            :to="getLangUrlItem(extractPathFromUrl(item?.url), baseUrl, locale)"  class="product-link"
            no-prefetch
             @click="handleClick"
            @mousedown="handleMouseDown"
            >
            <div class="product-image-wrapper">
                <img :src="item?.image_url" alt="" class="product-image" />
                <div class="cs_sale_discount" v-if="saleDiscountRounded(item.discount.MYR) > 4">
                    <img src="@/assets/images/vc-02.svg" class="sale-discount-image" />
                    <p>-{{ saleDiscountRounded(item?.discount.MYR) }}%</p>
                </div>
            </div>
            <div class="listing-item__info">
                <p class="listing-item__info-name">{{ htmlSpecialcharsDecode(item.name) }}</p>
                <div class="product-price cs_sr_price">
                    <p class="item_search_price">{{ displayCustomPrice(item.price.MYR) }}</p>
                    <p class="item_search_price_origin" v-if="item.original_price.MYR > item.price.MYR">
                        U.P.{{ displayCustomPrice(item.original_price.MYR) }}</p>
                </div>
            </div>
        </NuxtLink>
    </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import { extractPathFromUrl } from '~/utils/extractPathFromUrl';
import { setCookie } from "@/utils/cookie";
import type { IDataSearch } from "~/types/productItem";
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl, getLangUrlItem } from '~/utils/getLangUrl';
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;

// const props = defineProps(["item", "dataSearch", "index"]);
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required: true
  },
  dataSearch: {
    type: [Object, Array, String, null],
    required: false,
    default: null
  },
  insiderSearch: {
    type: Boolean
  }
});

//console.log('----defineProps ',props.item)

const saleDiscountRounded = (value: any) => {
    return Math.floor(Number(value) || 0)
}
// const insiderTrackingClick = (url: string, productId: string | string,price: number,position: number, dataSearch:IDataSearch) => {
//     const value = JSON.stringify({
//         url,
//         productId,
//         price,
//         position,
//         dataSearch
//     })

//     console.log('----- insider value',value);

//     setCookie('insider_product_click', value, 20)
//     }

// Desktop: Left click
const handleClick = (event: MouseEvent) => {
//console.log('---- click')
  trackProductClick();
};

// Desktop: Middle click & Right click
const handleMouseDown = (event: MouseEvent) => {
  if (event.button === 1 || event.button === 2) {
  //console.log('---- MouseEvent',event.button)
    trackProductClick();
  }
};

const trackProductClick = () => {

    //console.log('---- props.insiderSearch',props.insiderSearch)
  if (!props.insiderSearch) return;
  
  const trackingData = {
    url: extractPathFromUrl(props.item.url),
    productId: props.item.item_id,
    price: props.item.price.MYR,
    position: props.index,
    dataSearch: props?.dataSearch,
    timestamp: Date.now(),
    device: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
  };

  //console.log('---- trackingData',trackingData)
  
  // 1. Lưu cookie
  const cookieName = 'insider_product_click';
  try {
    let items: any[] = [];
    const cookieValue = getCookie(cookieName);
    
    if (cookieValue) {
      items = JSON.parse(cookieValue);
    }
    
    items.push(trackingData);
    setCookie(cookieName, JSON.stringify(items),20);
    
  } catch (error) {
    console.error('Cookie error:', error);
  }
  
};


const insiderTrackingClick = (
    url: string,
    productId: string,
    price: number,
    position: number,
    dataSearch: IDataSearch
) => {
    if (!props.insiderSearch) return;
    const cookieName = 'insider_product_click'

    let items: any[] = []

    const cookieValue = getCookie(cookieName)
    if (cookieValue) {
        try {
            items = JSON.parse(cookieValue)
            if (!Array.isArray(items)) items = []
        } catch {
            items = []
        }
    }

    const newItem = {
        url,
        productId,
        price,
        position,
        dataSearch
    }

    const index = items.findIndex(item => item.productId === productId)

    if (index !== -1) {
        items[index] = newItem
    } else {
        items.push(newItem)
    }

    setCookie(cookieName, JSON.stringify(items), 20)

    //console.log('----- insider click cookie', items)
}

onMounted(() => {

});


</script>
<style scoped lang="scss">
@import "@/assets/scss/components/listing/listingItem.scss";

.listing-item.item_search {
    width: 100%;

    @media screen and (max-width: 768px) {
        max-width: 100%;
        box-sizing: border-box;
        min-width: 0;
    }

    .product-link {
        display: block;

        @media screen and (max-width: 768px) {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            min-width: 0;
        }
    }

    .listing-item__info {
        @media screen and (max-width: 768px) {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            min-width: 0;
            overflow: hidden;

            &-name {
                width: 100%;
                word-wrap: break-word;
                overflow-wrap: break-word;
            }
        }
    }

    .product-price {
        &.cs_sr_price {
            display: flex;
            gap: 5px;
            padding-bottom: 10px;

            p {
                margin-bottom: 0;
            }

            .item_search_price {
                color: #212529 !important;
                font-weight: 600 !important;
                letter-spacing: 1px;
                line-height: 18px;
            }

            .item_search_price_origin {
                color: #a0a0a0 !important;
                font-weight: 600 !important;
                letter-spacing: 1px;
                line-height: 18px;
            }
        }
    }

    .product-image-wrapper {
        position: relative;
        width: 100%;

        @media screen and (max-width: 768px) {
            max-width: 100%;
            min-width: 0;
            box-sizing: border-box;
        }

        .product-image {
            width: 100%;
            height: auto;
            display: block;

            @media screen and (max-width: 768px) {
                max-width: 100%;
                object-fit: cover;
            }
        }

        .cs_sale_discount {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;

            p {
                align-items: center;
                color: #fff;
                font-size: 14px;
                padding-left: 2px;
                position: relative;
                right: -5px;
                top: -25px;
                z-index: 5;
            }

            .sale-discount-image {
                height: 30px;
                width: 55px;
            }

        }
    }

}


:deep(.customise_tag_detail) {
    background: #FFEEE6;
    text-transform: capitalize;
    color: #C60C46;
    font-size: 14px;
    padding: 5px 8px;
}

// :deep(.listing-item__media-sale-info .tag_detail:nth-child(n+2)) {
//   display: none;
// }
@media screen and (max-width: 768px) {
    :deep(.listing-item__media-sale-info .tag_detail) {
        display: none;
    }

    :deep(.listing-item__media-sale-info .tag_detail:last-child) {
        display: block !important;
    }
}
</style>
